import React from "react";
import { useCallback } from "react";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import ProjectCard from "../ProjectCard/ProjectCard";

const Projects = () => {
  const particlesInit = useCallback(async (engine) => {
    console.log(engine);
    // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
    await console.log(container);
  }, []);
  const cardData = [
    {
      id: 1,
      name: "Code Cove",
      github: "https://github.com/rahatsikz/Code-Cove",
      live: "https://code-cove-rat.web.app",
      image: "https://i.ibb.co/Lz2V9vf/code-cove-1.jpg",
      description: "Online Educational Website",
    },
    {
      id: 2,
      name: "Snapletics",
      github: "https://github.com/rahatsikz/snapletics-client",
      live: "https://snapletics-rat.web.app",
      image: "https://i.ibb.co/3RtFbxL/snapletics-1.jpg",
      description: "Service Review Website",
    },
    {
      id: 3,
      name: "2nd Time Around",
      github: "https://github.com/rahatsikz/second-time-around",
      live: "https://rat-second-time-around.web.app",
      image: "https://i.ibb.co/wBmxvXw/second-time-1.jpg",
      description: "Product Reselling Website",
    },
    {
      id: 4,
      name: "PC Craftsman",
      github: "https://github.com/rahatsikz/pc-craftsman",
      live: "https://pc-craftsman.vercel.app",
      image: "https://i.ibb.co/tDnDCVF/Pc-craft2.png",
      description: "PC Builder Website",
    },
  ];

  return (
    <section>
      <div className="h-[100vh] grid grid-cols-12 !mt-8 md:!mt-72 lg:mt-0">
        <div className="bg-secondary lg:col-span-3 col-span-12 text-white flex items-center justify-center">
          <p className="lg:-rotate-90 text-6xl font-bold uppercase lg:tracking-widest">
            Projects
          </p>
        </div>
        <div className="bg-slate-900 lg:col-span-9 col-span-12 text-white relative">
          <div
            className="grid md:grid-cols-2 2xl:grid-cols-2 lg:gap-8  gap-4 w-11/12 md:!-translate-x-1/2 md:!-translate-y-1/2 pb-4 lg:pb-0"
            style={{
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%,-27%)",
            }}
          >
            {cardData.map((card) => (
              <ProjectCard key={card.id} card={card}></ProjectCard>
            ))}
          </div>
          <Particles
            className="lg:h-[100vh] h-[50vh]"
            id="tsparticles1"
            init={particlesInit}
            loaded={particlesLoaded}
            options={{
              background: {
                color: {
                  value: "#0F172A",
                },
              },
              fullScreen: {
                enable: false,
                zIndex: -1,
              },
              fpsLimit: 120,
              interactivity: {
                events: {
                  onClick: {
                    enable: true,
                    mode: "push",
                  },
                  onHover: {
                    enable: true,
                    mode: "repulse",
                  },
                  resize: true,
                },
                modes: {
                  push: {
                    quantity: 4,
                  },
                  repulse: {
                    distance: 200,
                    duration: 0.4,
                  },
                },
              },
              particles: {
                color: {
                  value: "#ffffff",
                },
                links: {
                  color: "#ffffff",
                  distance: 150,
                  enable: true,
                  opacity: 0.5,
                  width: 1,
                },
                collisions: {
                  enable: true,
                },
                move: {
                  directions: "none",
                  enable: true,
                  outModes: {
                    default: "bounce",
                  },
                  random: false,
                  speed: 2,
                  straight: false,
                },
                number: {
                  density: {
                    enable: true,
                    area: 2800,
                  },
                  value: 80,
                },
                opacity: {
                  value: 0.5,
                },
                shape: {
                  type: "circle",
                },
                size: {
                  value: { min: 1, max: 5 },
                },
              },
              detectRetina: true,
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default Projects;
